/* eslint-disable no-param-reassign */
export const resolveProductDataLuluAttributes = (
  item,
  countryCode,
  extensions
) => {
  const { color, quantity, attributes, version } = extensions;
  return {
    type: "product",
    product: {
      name: item.productName,
      skuID: `${countryCode.toLowerCase()}_${item.selectedSku?.id}`,
      categoryUnifiedID: item.category?.unifiedId,
      color: color || item.selectedSku?.color?.name,
      size: item.selectedSku?.size,
      deliveryType: item.isBopis ? "pickup" : "ship",
      quantity: quantity || 1,
      price:
        item.selectedSku?.salePricePerItem ||
        item.selectedSku?.originalPricePerItem
    },
    ...(attributes && { attributes }),
    ...(version && { version })
  };
};

export const serializeDataLuluAttributes = (dataLuluAttrs) => ({
  "data-lulu-attributes": JSON.stringify(dataLuluAttrs)
});

export const getProductDataLuluAttributes = (
  item,
  countryCode,
  extensions = {}
) =>
  serializeDataLuluAttributes(
    resolveProductDataLuluAttributes(item, countryCode, extensions)
  );

export const getWishlistItemDataLuluAttributes = ({
  product,
  attributes,
  version,
  countryCode
}) => {
  const {
    color,
    colorDislayName,
    sku,
    size,
    priceDetails,
    displayName, // from recommendations
    productName, // from products
    defaultSku,
    parentCategoryUnifiedId,
    skuStyleNumber,
    skuStyleOrder,
    skuId,
    productId
  } = product;
  const listPrice = priceDetails?.listPrice || product?.listPrice;
  const salePrice = priceDetails?.salePrice || product?.salePrice;

  const parsePrice = (input) => {
    if (Array.isArray(input)) {
      return input?.[0];
    }

    return input;
  };

  if (skuStyleOrder && attributes) {
    if (skuStyleOrder?.[0]?.skuStyleOrderId) {
      attributes.position = skuStyleOrder[0].skuStyleOrderId;
    }
  }

  return {
    "data-lulu-attributes": JSON.stringify({
      type: "product",
      product: {
        productID: productId,
        name: displayName || productName,
        skuID:
          defaultSku ||
          (sku && `${countryCode?.toLowerCase()}_${sku}`) ||
          (skuId && `${countryCode?.toLowerCase()}_${skuId}`),
        categoryUnifiedID: parentCategoryUnifiedId,
        color: color || colorDislayName || skuStyleOrder?.[0]?.colorName,
        size, // not available from recommendations
        deliveryType: null, // not currently supported
        quantity: 1, // not currently supported
        price: parsePrice(salePrice) || parsePrice(listPrice),
        styleID: skuStyleOrder?.[0]?.styleId || skuStyleNumber?.[0]
      },
      ...(attributes && { attributes }),
      ...(version && { version })
    })
  };
};

export const getTestAttributes = (type, name, id, details = "") => {
  return {
    "data-lulu-attributes": JSON.stringify({
      type: "component",
      component: {
        type,
        name,
        id
      },
      ...(details && { details })
    })
  };
};
